import { staffBasePath } from "@oysterhr/router"
import { BackgroundProcessType } from "../../pages/AdminActivityLogPage/constants"
import { idToStrongId } from "@oysterhr/common"

export const staffInvoicesPath = (queryOrHash = "") =>
  staffBasePath({ scope: `invoices${queryOrHash}` })

export const staffInvoicesNewPath = () => staffBasePath({ scope: "invoices", path: "new" })

export const staffCreateContractorInvoicePath = (contractorId: string) =>
  staffBasePath({
    scope: "invoices/new/contractor",
    id: contractorId,
  })

export const staffInvoiceDetailsPath = (invoiceId: string) =>
  staffBasePath({ scope: "invoices", id: invoiceId, path: "details" })

export const staffInvoiceEditPath = (id: string) =>
  staffBasePath({ scope: "invoices", id, path: "edit" })

export const staffEditContractorInvoicePath = (invoiceId: string) =>
  staffBasePath({
    scope: "invoices",
    id: invoiceId,
    path: "contractor/edit",
  })

export const staffInvoicesLoadVendorDataPath = () =>
  staffBasePath({ scope: "invoices", path: "load-vendor-data" })

export const staffInvoicesLoadVendorDataItemPath = (id: string) =>
  staffBasePath({ scope: "invoices", path: `load-vendor-data/${idToStrongId(id)}` })

export const staffInvoicesGenerateDepositInvoicePath = () =>
  staffBasePath({ scope: "invoices", path: "generate-deposit-invoice" })

export const staffInvoicesBatchesPath = () => staffBasePath({ scope: "invoices-batches" })

export const staffInvoicesBatchPath = (invoicesBatchId: string) =>
  staffBasePath({ scope: "invoices-batches", id: invoicesBatchId })

export const staffInvoicesIssuesBatchPath = (invoicesBatchId: string) =>
  staffBasePath({ scope: "invoices-batches", id: invoicesBatchId, path: "issues" })

export const staffCreditNotesPath = (query = "") =>
  staffBasePath({
    scope: "invoices",
    query: query,
    hash: "creditNotes",
  })

export const staffCreditNoteNewPath = () =>
  staffBasePath({
    scope: "creditnotes",
    path: "new",
  })

export const staffCreditNoteGeneratePath = () =>
  staffBasePath({
    scope: "creditnotes",
    path: "generate",
  })

export const staffApplyCreditNotePath = (companyId: string, creditNoteId: string) =>
  staffBasePath({
    scope: "creditnotes",
    id: companyId,
    path: `apply/${idToStrongId(creditNoteId)}`,
  })

export const staffActivityLogPath = (processType: string = "") =>
  staffBasePath({ scope: "activity-log", hash: processType })

export const staffBackgroundProcessPath = (id: string, type?: BackgroundProcessType) =>
  staffBasePath({ scope: "activity-log", id: id, query: type && `type=${type}` })
